import { API_ENV, NODE_ENV } from '@/config/env'
const API_URLS = {
  base: {
    'development': 'http://test-manager-gateway.miguatech.com',
    'production': {
      'test': 'http://test-manager-gateway.miguatech.com',
      'uat': 'http://uat-manager-gateway.miguatech.com',
      'sit': 'https://gray.miguatech.com',
      'prod': 'https://manager-gateway.aomiapp.com'
    }
  },
  login: {
    'development': 'http://test-manager-gateway.miguatech.com',
    'production': {
      'test': 'http://test-manager-gateway.miguatech.com',
      'uat': 'http://uat-manager-gateway.miguatech.com',
      'sit': 'https://gray.miguatech.com',
      'prod': 'https://manager-gateway.aomiapp.com'
    }
  }
}
export function getUrl (name) {
  return API_URLS[name][NODE_ENV][API_ENV] || API_URLS[name][NODE_ENV]
}
